import SvgIcon from 'common/components/svg-icon';


const TwitterIcon = (props) => (
    <SvgIcon { ...props }>
        <path
            clipRule='evenodd'
            d='m34.167,18.283c-2.619,0.953 -4.274,3.411 -4.086,6.101l0.063,1.038l-1.048,-0.127c-3.813,-0.487 -7.145,-2.139 -9.974,-4.915l-1.383,-1.377l-0.356,1.017c-0.754,2.267 -0.272,4.661 1.299,6.271c0.838,0.89 0.649,1.017 -0.796,0.487c-0.503,-0.169 -0.943,-0.296 -0.985,-0.233c-0.146,0.149 0.356,2.076 0.754,2.839c0.545,1.06 1.655,2.097 2.871,2.712l1.027,0.487l-1.215,0.021c-1.173,0 -1.215,0.021 -1.089,0.467c0.419,1.377 2.074,2.839 3.918,3.475l1.299,0.444l-1.131,0.678c-1.676,0.976 -3.646,1.526 -5.616,1.567c-0.944,0.021 -1.719,0.106 -1.719,0.17c0,0.211 2.557,1.397 4.044,1.864c4.463,1.377 9.765,0.783 13.746,-1.568c2.829,-1.674 5.657,-5 6.978,-8.221c0.713,-1.715 1.425,-4.851 1.425,-6.354c0,-0.975 0.063,-1.102 1.236,-2.267c0.692,-0.678 1.341,-1.419 1.467,-1.631c0.21,-0.403 0.188,-0.403 -0.88,-0.043c-1.781,0.636 -2.033,0.551 -1.152,-0.402c0.649,-0.678 1.425,-1.907 1.425,-2.267c0,-0.063 -0.314,0.042 -0.671,0.233c-0.377,0.212 -1.215,0.53 -1.844,0.72l-1.131,0.361l-1.027,-0.7c-0.566,-0.381 -1.361,-0.805 -1.781,-0.932c-1.069,-0.296 -2.704,-0.254 -3.668,0.085zm-34.167,-18.283l60,0l0,60l-60,0l0,-60z'
            fillRule='evenodd'
        />
    </SvgIcon>
);


export default TwitterIcon;



// WEBPACK FOOTER //
// ./src/common/components/svg-icon/twitter.js